import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Language } from '@breathelife/types';
import { Select, SelectProps } from '../Select/Select';

type LanguageSelectProps = Omit<SelectProps<Language>, 'options'> & {
  enabledLanguages: Language[];
};

export function LanguageSelect(props: LanguageSelectProps): ReactElement {
  const { t } = useTranslation();
  const { enabledLanguages } = props;

  const languageOptions = enabledLanguages.map((language) => ({
    value: language,
    label: t(`language.${language}`),
  }));

  return <Select {...props} options={languageOptions} />;
}
